import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a69f952"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blacklist-cntr" }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTree = _resolveComponent("BaseTree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    modelValue: _ctx.modalVisiable,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalVisiable) = $event)),
    "before-close": _ctx.closeModal,
    "destroy-on-close": "",
    width: "470px"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('groupClient.moveTerminalModalTitle', { count: _ctx.count })), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: _ctx.moveTerminal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BaseTree, {
          width: "100%",
          onTerminalGroupSelected: _ctx.terminalGroupSelected,
          foldable: false
        }, null, 8, ["onTerminalGroupSelected"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}